import { render, staticRenderFns } from "./SchaDonorTab1ListComp.vue?vue&type=template&id=17b9a9fc&scoped=true"
import script from "./SchaDonorTab1ListComp.vue?vue&type=script&lang=js"
export * from "./SchaDonorTab1ListComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b9a9fc",
  null
  
)

export default component.exports